import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewChildren,
} from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { round } from "lodash";
import * as localforage from "localforage";
import {
  InputBoolean,
  NzDatePickerComponent,
  NzInputNumberComponent,
  NzRangePickerComponent,
  NzSelectComponent,
  NzTimePickerComponent,
} from "ng-zorro-antd";
import { NzFormatEmitEvent } from "ng-zorro-antd/core";
import { Subject, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { TotalOption } from "../hd-detail-lines/hd-detail-lines.service";
import { TreeGrid } from "../hd-table/hd-table.service";
import { SelectOptionTableColumn } from "../model/common-type";
import { CommonSessionService } from "../service/common-session.service";
import { FormLine, FormLineType, FormLinesCacheOption } from "./hd-form-lines.service";

/** 与 ant-select 选项项水平内边距一致，用于表头与选项行对齐 */
const SELECT_TABLE_OPTION_HORIZONTAL_PADDING = 12;

@Component({
  selector: "hd-form-lines",
  templateUrl: "./hd-form-lines.component.html",
  styleUrls: ["./hd-form-lines.component.less"],
})
export class HdFormLinesComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren("formInputDom") formInputDomList!: QueryList<ElementRef>;

  @Input() @InputBoolean() showLineNumber: boolean = true;
  @Input() @InputBoolean() allowEmpty: boolean = true;
  @Output() deleteLastLineEvent = new EventEmitter();
  @Input() @InputBoolean() showKeyboardOperateTip: boolean = false;
  /** 是否启用键盘方向键/Enter 在单元格间跳转，默认开启 */
  @Input() @InputBoolean() enableKeyboardOperate: boolean = true;
  @Input() @InputBoolean() tableLoading: boolean = false;
  @Input() @InputBoolean() showSearch: boolean = false;
  /** 是否展示行勾选列，用于外部批量操作勾选行 */
  @Input() @InputBoolean() showCheckbox: boolean = false;
  /** 是否展示列设置（齿轮），默认关闭；需要时页面手工 `[showColSettings]="true"`；仅非 hide 的 ViewDom 可配置，禁止拖拽调序 */
  @Input() @InputBoolean() showColSettings: boolean = false;
  /** 列设置缓存 key 片段；有值时持久化到 IndexedDB，无则仅当前会话生效 */
  @Input() uuid: string;
  @Input() formLines: Array<FormLine>;
  // 针对formLines里面所有的name，
  @Input() formLinesData: any;
  @Input() operateButtons: Array<string> = ["add", "delete"]; // 操作列按钮：add / delete / copy
  @Input() scroll: { [key: string]: string } = { x: "1px" };
  @Output() changeEvent = new EventEmitter();
  /** 新增空行后抛出该行 FormGroup（手动添加、键盘跳行自动补行等） */
  @Output() addLineEvent = new EventEmitter<FormGroup>();
  /** 勾选变化时抛出当前勾选行 FormGroup 列表 */
  @Output() selectionChange = new EventEmitter<FormGroup[]>();
  @Input() @InputBoolean() showDeleteConfirm: boolean = false;
  paginationPageIndex: number = 1;
  paginationPageSize: number = 10;
  validateHdFormLines: FormGroup;
  newLine: any;
  inputValue: string;

  // 合计区域
  @Input() @InputBoolean() showTotal: boolean = false;
  @Input() totalOption: Array<TotalOption> = [];
  @Input() columnsNumber: number | string = 0;
  totalOptionList = [];

  showForm: boolean = false;
  filterStr: string;
  storeFormLinesData: any = []; // 缓存的总的表单数据
  filterStoreFormLinesData: any = []; // 筛选出来的数据列表
  filterIndexStore: Array<number> = []; // 筛选出来的数据在原始列表中的下标
  isFilterData: boolean = false; // 是否是已经筛选过的数据
  formValid: boolean = false; // 表单当前的状态
  /** 勾选的行 id（跨页、搜索重建后仍保留） */
  private selectedRowIds = new Set<string>();
  private searchSubject = new Subject<{ fn: any; event: any; line: any }>();
  private debounceTimeout: number = 0; // 默认防抖时间

  private searchSubscription: Subscription | undefined;
  private formInputDomListSub: Subscription | undefined;

  private openChangeSubject = new Subject<{ fn: any; event: any; line: any }>();
  private openChangeDebounceTimeout: number = 0;
  private openChangeSubscription: Subscription | undefined;

  // 当前页的dom二维数组
  collectDomList: Array<
    Array<
      | ElementRef
      | NzSelectComponent
      | NzInputNumberComponent
      | NzDatePickerComponent
      | NzRangePickerComponent
      | NzTimePickerComponent
    >
  > = [];
  // 当前聚焦的dom元素坐标
  activeDomX: number = null;
  activeDomY: number = null;
  activeDom:
    | ElementRef
    | NzSelectComponent
    | NzInputNumberComponent
    | NzDatePickerComponent
    | NzRangePickerComponent
    | NzTimePickerComponent = null;
  activeSelectedComponentOpen: boolean = false;
  @ContentChild("ViewDomRightTemplate", { static: false })
  ViewDomRightTemplate: TemplateRef<any>;
  /** 工具栏左侧自定义按钮，用法同 hd-table 的 tableLeftButton */
  @ContentChild("formLinesLeftButton", { static: false })
  formLinesLeftButton: TemplateRef<any>;
  /** 工具栏右侧自定义按钮，用法同 hd-table 的 tableRightButton */
  @ContentChild("formLinesRightButton", { static: false })
  formLinesRightButton: TemplateRef<any>;
  /** 表格上方自定义区域（如勾选提示），用法同 hd-table 的 tableTotal */
  @ContentChild("tableTotal", { static: false })
  tableTotal: TemplateRef<any>;

  // 列设置
  isDropdownVisible: boolean = false;
  showListNodes: boolean = false;
  nowListNodes: Array<TreeGrid> = [];
  hideListNodes: Array<TreeGrid> = [];
  cancelNowListNodes: Array<TreeGrid> = [];
  cancelHideListNodes: Array<TreeGrid> = [];
  formLinesCacheOption: FormLinesCacheOption = new FormLinesCacheOption();
  private localforage: any = null;
  private localtionTmp: string = "";
  private userSession: any;
  /** 是否已从 IndexedDB 读到过列设置缓存（含 cols 为空） */
  private colsCacheLoaded: boolean = false;

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private commonSessionService: CommonSessionService,
  ) {
    this.localforage = localforage.createInstance({
      driver: localforage.INDEXEDDB,
      name: "hd-fscm",
      version: 1.0,
      storeName: "hd-fscm-store",
    });
    this.searchSubscription = this.searchSubject
      .pipe(debounceTime(this.debounceTimeout))
      .subscribe(({ fn, event, line }) => this.triggerEvent(fn, event, line));
    this.openChangeSubscription = this.openChangeSubject
      .pipe(debounceTime(this.openChangeDebounceTimeout))
      .subscribe(({ fn, event, line }) => {
        if (event) {
          this.triggerEvent(fn, event, line);
        }
      });
  }

  ngOnInit() {
    this.localtionTmp = location.pathname;
    if (this.localtionTmp) {
      this.localtionTmp = this.localtionTmp.replace(/\//g, "_");
    }
    this.userSession = this.commonSessionService.getSession(
      "__jy_authorization_session__",
    );
    if (!this.userSession) {
      this.userSession = { userCode: "dev" };
    }
    // 缓存一下总的表单数据
    this.storeFormLinesData = this.formLinesData;
    this.initColSettings();
    this.init();
  }

  ngAfterViewInit() {
    this.collectDomData();
    this.formInputDomListSub = this.formInputDomList.changes.subscribe(() => {
      this.collectDomData();
    });
  }

  ngOnDestroy() {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.openChangeSubscription) {
      this.openChangeSubscription.unsubscribe();
    }
    if (this.formInputDomListSub) {
      this.formInputDomListSub.unsubscribe();
    }
  }

  get formLinesLength() {
    return this.linesFormArray.controls.length;
  }

  get operateColWidth() {
    const count = (this.operateButtons || []).filter((btn) =>
      ["add", "copy", "delete"].includes(btn),
    ).length;
    return Math.max(count * 40, 80);
  }

  /** allowEmpty 且操作列仅有删除时：允许 0 行，初始化与删至空都不自动补空行 */
  get isTrulyEmptyAllowed(): boolean {
    const buttons = (this.operateButtons || []).filter((btn) =>
      ["add", "copy", "delete"].includes(btn),
    );
    return (
      this.allowEmpty &&
      buttons.length === 1 &&
      buttons[0] === "delete"
    );
  }

  /** 勾选列固定时，序号列的 left 偏移 */
  get lineNumberLeft() {
    return this.showCheckbox ? "40px" : "0px";
  }

  private generateRowId(): string {
    return `hd_row_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
  }

  private getRowId(line: FormGroup): string {
    if (!line || !line.get("_hdRowId")) {
      return null;
    }
    return line.get("_hdRowId").value;
  }

  /** 当前页的行（用于表头全选，仅作用于当前页，跨页勾选仍保留） */
  private getCurrentPageLines(): FormGroup[] {
    const start = (this.paginationPageIndex - 1) * this.paginationPageSize;
    const end = start + this.paginationPageSize;
    return (this.linesFormArray.controls as FormGroup[]).slice(start, end);
  }

  isLineChecked(line: FormGroup): boolean {
    const id = this.getRowId(line);
    return !!id && this.selectedRowIds.has(id);
  }

  isAllChecked(): boolean {
    const pageLines = this.getCurrentPageLines();
    return (
      pageLines.length > 0 &&
      pageLines.every((line) => this.isLineChecked(line))
    );
  }

  isIndeterminate(): boolean {
    const pageLines = this.getCurrentPageLines();
    const checkedCount = pageLines.filter((line) =>
      this.isLineChecked(line),
    ).length;
    return checkedCount > 0 && checkedCount < pageLines.length;
  }

  onAllChecked(checked: boolean): void {
    this.getCurrentPageLines().forEach((line) => {
      const id = this.getRowId(line);
      if (!id) {
        return;
      }
      if (checked) {
        this.selectedRowIds.add(id);
      } else {
        this.selectedRowIds.delete(id);
      }
    });
    this.emitSelectionChange();
  }

  onLineCheckedChange(line: FormGroup, checked: boolean): void {
    const id = this.getRowId(line);
    if (!id) {
      return;
    }
    if (checked) {
      this.selectedRowIds.add(id);
    } else {
      this.selectedRowIds.delete(id);
    }
    this.emitSelectionChange();
  }

  private emitSelectionChange(): void {
    this.selectionChange.emit(this.getSelectedLines());
    this.cdr.markForCheck();
  }

  private removeLineFromSelection(line: FormGroup): void {
    const id = this.getRowId(line);
    if (id && this.selectedRowIds.has(id)) {
      this.selectedRowIds.delete(id);
      this.emitSelectionChange();
    }
  }

  private applyValuesToLine(
    line: FormGroup,
    values: { [field: string]: any },
    emitEvent: boolean,
  ): void {
    Object.keys(values).forEach((key) => {
      let control = line.get(key);
      if (!control) {
        line.addControl(key, this.fb.control(values[key]));
        control = line.get(key);
      }
      // 静默赋值，避免 valueChanges / DOM maxlength 回写把校验态打乱
      control.setValue(values[key], { emitEvent: false });
      control.markAsPristine({ onlySelf: true });
      control.markAsUntouched({ onlySelf: true });
      control.updateValueAndValidity({ emitEvent: false });
      if (emitEvent) {
        const formItem = this.formLines.find((item) => item.name === key);
        if (formItem && formItem.onChangeEvent) {
          this.triggerEvent(formItem.onChangeEvent, values[key], line);
        }
      }
    });
    this.cdr.detectChanges();
  }

  /**
   * 仅在用户交互后、且当前值确实为空的 required 错误时展示红框，
   * 避免批量赋值时 ng-zorro 残留「不能为空」提示
   */
  getControlValidateStatus(line: FormGroup, formItem: FormLine): string {
    const control = line.get(formItem.name);
    if (!control || control.disabled) {
      return "";
    }
    const empty =
      control.value === null ||
      control.value === undefined ||
      control.value === "";
    if (
      (control.dirty || control.touched) &&
      empty &&
      control.hasError("required")
    ) {
      return "error";
    }
    return "";
  }

  /** 用户输入时按 maxLength 截断（不使用原生 maxlength，避免干扰程序化赋值） */
  limitInputLength(event: Event, line: FormGroup, formItem: FormLine): void {
    if (!formItem || !formItem.maxLength) {
      return;
    }
    const input = event.target as HTMLInputElement;
    if (input && input.value && input.value.length > formItem.maxLength) {
      const next = input.value.slice(0, formItem.maxLength);
      input.value = next;
      const control = line.get(formItem.name);
      if (control) {
        control.setValue(next);
      }
    }
  }

  /** 获取当前勾选且已挂载的行 FormGroup（当前筛选结果内） */
  public getSelectedLines(): FormGroup[] {
    return (this.linesFormArray.controls as FormGroup[]).filter((line) =>
      this.isLineChecked(line),
    );
  }

  /**
   * 获取全部勾选行数据（含跨页、搜索后未展示但仍勾选的行）
   */
  public getSelectedLinesData(): any[] {
    const result = [];
    const mountedById = new Map<string, any>();
    (this.linesFormArray.controls as FormGroup[]).forEach((line) => {
      const id = this.getRowId(line);
      if (id && this.selectedRowIds.has(id)) {
        mountedById.set(id, line.getRawValue());
      }
    });

    (this.storeFormLinesData || []).forEach((data) => {
      const id = data && data._hdRowId;
      if (id && this.selectedRowIds.has(id)) {
        result.push(mountedById.has(id) ? mountedById.get(id) : { ...data });
      }
    });

    // 兜底：刚新增、尚未进 store 的勾选行
    this.selectedRowIds.forEach((id) => {
      if (
        !result.some((item) => item && item._hdRowId === id) &&
        mountedById.has(id)
      ) {
        result.push(mountedById.get(id));
      }
    });
    return result;
  }

  /**
   * 批量填充勾选行字段（支持跨页、搜索后未展示但仍勾选的行）
   * @param values 要写入的字段，如 { remark: '批量备注', price: 10 }
   * @param emitEvent 是否触发 valueChanges / onChangeEvent，默认 true
   * @returns 实际填充的行数
   */
  public batchFillSelected(
    values: { [field: string]: any },
    emitEvent: boolean = true,
  ): number {
    if (!values || this.selectedRowIds.size === 0) {
      return 0;
    }
    const mountedById = new Map<string, FormGroup>();
    (this.linesFormArray.controls as FormGroup[]).forEach((line) => {
      const id = this.getRowId(line);
      if (id) {
        mountedById.set(id, line);
      }
    });

    let count = 0;
    this.selectedRowIds.forEach((id) => {
      const line = mountedById.get(id);
      if (line) {
        this.applyValuesToLine(line, values, emitEvent);
        count++;
        return;
      }
      // 当前筛选/页面未挂载：直接改总数据，退出搜索后可见
      const storeItem = (this.storeFormLinesData || []).find(
        (data) => data && data._hdRowId === id,
      );
      if (storeItem) {
        Object.keys(values).forEach((key) => {
          storeItem[key] = values[key];
        });
        count++;
      }
    });
    return count;
  }

  /** 清空勾选 */
  public clearSelection(): void {
    if (this.selectedRowIds.size === 0) {
      return;
    }
    this.selectedRowIds.clear();
    this.emitSelectionChange();
  }

  /** 当前勾选数量（含跨页、搜索保留） */
  public getSelectedCount(): number {
    return this.selectedRowIds.size;
  }

  /** 是否展示顶部工具栏 */
  get showToolbar(): boolean {
    return (
      !!this.showSearch ||
      !!this.showCheckbox ||
      !!this.formLinesLeftButton ||
      !!this.formLinesRightButton ||
      this.showColSettingsButton
    );
  }

  /** 是否展示列设置齿轮（有可配置 ViewDom 时） */
  get showColSettingsButton(): boolean {
    return (
      !!this.showColSettings && this.getConfigurableFormLines().length > 0
    );
  }

  /** 列是否渲染：hide 永不展示；ViewDom 受 isShow 控制 */
  isColumnVisible(item: FormLine): boolean {
    if (!item || item.hide) {
      return false;
    }
    if (item.type === FormLineType.ViewDom) {
      return item.isShow !== false;
    }
    return true;
  }

  /** 可进入列设置的字段：非 hide 的 ViewDom */
  getConfigurableFormLines(): FormLine[] {
    if (!this.formLines || !this.formLines.length) {
      return [];
    }
    return this.formLines.filter(
      (item) => item.type === FormLineType.ViewDom && !item.hide,
    );
  }

  private getCacheKey(): string {
    const userCode =
      (this.userSession && this.userSession.userCode) || "dev";
    return (
      "hd-form-lines_" +
      userCode +
      "_" +
      this.localtionTmp +
      "_" +
      this.uuid
    );
  }

  private initColSettings(): void {
    this.colsCacheLoaded = false;
    if (!this.showColSettings || !this.formLines || !this.formLines.length) {
      this.setCols();
      return;
    }
    if (!this.uuid) {
      this.setCols();
      return;
    }
    this.localforage
      .ready()
      .then(() => {
        this.localforage
          .getItem(this.getCacheKey())
          .then((value: FormLinesCacheOption) => {
            if (value && Array.isArray(value.cols)) {
              this.formLinesCacheOption = value;
              this.colsCacheLoaded = true;
            } else {
              this.formLinesCacheOption = new FormLinesCacheOption();
              this.colsCacheLoaded = false;
            }
            this.setCols();
          })
          .catch(() => {
            this.formLinesCacheOption = new FormLinesCacheOption();
            this.colsCacheLoaded = false;
            this.setCols();
          });
      })
      .catch((e) => {
        console.log("localforage加载异常", e);
        this.formLinesCacheOption = new FormLinesCacheOption();
        this.colsCacheLoaded = false;
        this.setCols();
      });
  }

  private hasColsCache(): boolean {
    return this.colsCacheLoaded && Array.isArray(this.formLinesCacheOption.cols);
  }

  private saveFormLinesCacheOption(): void {
    if (!this.uuid) {
      return;
    }
    this.localforage.setItem(this.getCacheKey(), this.formLinesCacheOption);
  }

  /** 按 formLines 原始顺序排列节点（禁止调序时保持源顺序） */
  private sortNodesByFormLinesOrder(nodes: TreeGrid[]): TreeGrid[] {
    const order = this.getConfigurableFormLines().map((f) => f.name);
    return nodes.slice().sort((a, b) => {
      return order.indexOf(a.key) - order.indexOf(b.key);
    });
  }

  setCols(): void {
    this.showListNodes = false;
    this.nowListNodes = [];
    this.hideListNodes = [];
    const configurable = this.getConfigurableFormLines();
    const hasCache = this.hasColsCache();
    configurable.forEach((element) => {
      if (hasCache) {
        element.isShow = this.formLinesCacheOption.cols.includes(element.name);
      } else if (element.isShow === undefined || element.isShow === null) {
        element.isShow = true;
      }
      const node: TreeGrid = {
        title: element.label,
        key: element.name,
        checked: element.isShow !== false,
        disabled: false,
      };
      if (element.isShow !== false) {
        this.nowListNodes.push(node);
      } else {
        this.hideListNodes.push(node);
      }
    });
    this.nowListNodes = this.sortNodesByFormLinesOrder(this.nowListNodes);
    this.hideListNodes = this.sortNodesByFormLinesOrder(this.hideListNodes);
    setTimeout(() => {
      this.showListNodes = true;
      this.cdr.markForCheck();
    }, 0);
  }

  cancelDropdown(): void {
    this.isDropdownVisible = false;
    this.hideListNodes = JSON.parse(JSON.stringify(this.cancelHideListNodes));
    this.nowListNodes = JSON.parse(JSON.stringify(this.cancelNowListNodes));
    this.cdr.markForCheck();
  }

  confirmDropdown(): void {
    this.cancelHideListNodes = JSON.parse(JSON.stringify(this.hideListNodes));
    this.cancelNowListNodes = JSON.parse(JSON.stringify(this.nowListNodes));
    this.isDropdownVisible = true;
    this.cdr.markForCheck();
  }

  submitGrids(): void {
    const visibleNames = this.nowListNodes.map((item) => item.key);
    this.getConfigurableFormLines().forEach((line) => {
      line.isShow = visibleNames.includes(line.name);
    });
    this.formLinesCacheOption.cols = visibleNames;
    this.colsCacheLoaded = true;
    this.saveFormLinesCacheOption();
    this.isDropdownVisible = false;
    this.cdr.markForCheck();
  }

  /** 勾选/取消：仅在显示/隐藏两组间移动，不改变 formLines 顺序 */
  checkAction(event: NzFormatEmitEvent): void {
    if (event.node.origin.checked) {
      const node = this.hideListNodes.find((item) => {
        return item.key === event.node.origin.key;
      });
      if (!node) {
        return;
      }
      node.checked = true;
      this.hideListNodes = this.hideListNodes.filter((item) => {
        return item.key !== event.node.origin.key;
      });
      this.nowListNodes = this.sortNodesByFormLinesOrder(
        this.nowListNodes.concat([node]),
      );
    } else {
      const temporaryNodeList = this.hideListNodes.slice(0);
      this.nowListNodes.forEach((item) => {
        if (item.key === event.node.origin.key) {
          const innerItem = JSON.parse(JSON.stringify(item));
          innerItem.checked = false;
          temporaryNodeList.push(innerItem);
        }
      });
      this.hideListNodes = this.sortNodesByFormLinesOrder(temporaryNodeList);
      this.nowListNodes = this.nowListNodes.filter((item) => {
        return item.key !== event.node.origin.key;
      });
    }
    this.cdr.markForCheck();
  }

  setActiveSelectedComponentOpen(value: boolean) {
    this.activeSelectedComponentOpen = value;
    if (value === true) {
      setTimeout(() => {
        const domList = document.querySelectorAll(
          ".ant-select-dropdown.hd-select-table",
        );
        if (domList.length > 0) {
          const dom = domList[0];
          dom
            .querySelectorAll(".hd-option-header")
            .forEach((header) => header.remove());
          const oldIndex = this.getOldDomIndex(this.activeDomY, this.formLines);
          dom.insertBefore(
            this.createDOMStructure(
              this.formLines[oldIndex],
              this.linesFormArray.controls.slice(
                (this.paginationPageIndex - 1) * this.paginationPageSize,
                (this.paginationPageIndex - 1) * this.paginationPageSize +
                  this.paginationPageSize,
              )[this.activeDomX],
            ),
            dom.firstChild,
          );
        }
      }, 0);
    }
  }

  getSelectTableColumnStyle(column: SelectOptionTableColumn): {
    [key: string]: string;
  } {
    if (!column || !column.width) {
      return { width: "unset" };
    }
    return { width: `${column.width}px` };
  }

  createDOMStructure(formItem, line) {
    // 创建外部 div
    const hdOptionHeader = document.createElement("div");
    hdOptionHeader.className = "hd-option-header";
    hdOptionHeader.style.paddingLeft = `${SELECT_TABLE_OPTION_HORIZONTAL_PADDING}px`;
    hdOptionHeader.style.paddingRight = `${SELECT_TABLE_OPTION_HORIZONTAL_PADDING}px`;

    // 检查条件，确定是否要创建子元素
    // const selectListLength = (formItem && formItem.selectOption && formItem.selectOption.selectList && formItem.selectOption.selectList.length) || 0;
    // if
    // const lineValueLength = (line.get(formItem.selectOption.selectListName) && line.get(formItem.selectOption.selectListName).value && line.get(formItem.selectOption.selectListName).value.length) || 0;

    // if (selectListLength > 0 || lineValueLength > 0) {
    // 遍历 tableColumns 创建内部列 div
    formItem.selectOption.tableColumns.forEach((selectOptionTableColumn) => {
      const columnDiv = document.createElement("div");
      columnDiv.className = "hd-option-header-column";

      const widthStyle = this.getSelectTableColumnStyle(
        selectOptionTableColumn,
      );
      columnDiv.style.width = widthStyle.width;

      // 添加列标签内容
      if (selectOptionTableColumn.label) {
        const labelText = document.createTextNode(
          selectOptionTableColumn.label,
        );
        columnDiv.appendChild(labelText);
      }

      // 添加列 div 到外部 div
      hdOptionHeader.appendChild(columnDiv);
    });
    // }

    return hdOptionHeader;
  }

  collectDomData() {
    this.collectDomList = [];
    const pageDomList = this.formInputDomList.toArray();
    // Step 1: 获取当前页的数据量
    const startIndex = (this.paginationPageIndex - 1) * this.paginationPageSize;
    const endIndex = this.paginationPageIndex * this.paginationPageSize;
    const adjustedEndIndex =
      endIndex > this.formLinesLength ? this.formLinesLength : endIndex;
    const pageLinesLength = adjustedEndIndex - startIndex;

    const interval = pageDomList.length / pageLinesLength;
    // Step 2: 拆分formInputDomList
    for (let i = 0; i < pageLinesLength; i++) {
      this.collectDomList.push(pageDomList.splice(0, interval));
    }
    this.disableInputNumberKeyboardStep();
  }

  /**
   * ng-zorro 8 在 input 的 onKeyDown 里用上下键调 up()/down() 改 step。
   * 只覆盖 onKeyDown（不动 up/down），键盘方向键交给表单跳转，+/- 按钮仍可用。
   */
  private disableInputNumberKeyboardStep(): void {
    if (!this.enableKeyboardOperate) {
      return;
    }
    for (let i = 0; i < this.collectDomList.length; i++) {
      for (let j = 0; j < this.collectDomList[i].length; j++) {
        const dom = this.collectDomList[i][j];
        if (dom instanceof NzInputNumberComponent) {
          dom.onKeyDown = (e: KeyboardEvent) => {
            if (e.keyCode === 38 || e.keyCode === 40) {
              return;
            }
            if (e.keyCode === 13) {
              dom.setValidateValue();
            }
          };
        }
      }
    }
  }

  // 聚焦下一个dom
  jumpToNextInput(x: number, y: number) {
    if (
      x === null ||
      y === null ||
      !this.collectDomList ||
      this.collectDomList.length === 0
    ) {
      return;
    }
    // 如果是最后一个可输入元素，新增行
    if (
      !(this.activeDom instanceof NzSelectComponent) &&
      x === this.collectDomList.length - 1 &&
      y === this.collectDomList[0].length - 1
    ) {
      this.addNewLineAndFocus();
    } else {
      if (y === this.collectDomList[0].length - 1) {
        console.log("执行过程1");
        // 如果是最后一列，则跳转到下一行第一个输入框
        this.focusDom(x + 1, 0, "right");
      } else {
        console.log("执行过程2");
        // 如果不是最后一列，则跳转到当前行下一个输入框
        this.focusDom(x, y + 1, "right");
      }
    }
  }

  /**
   * 增加新行并且聚焦到第一个元素，
   * 这里要注意，如果存在翻页情况，需要处理
   */
  addNewLineAndFocus() {
    // 当前行为当前页最后一行的时候，判断下一页是否有数据
    // 1、如果有：翻页+聚焦第一行第一个元素
    // 2、如果没有：新增行+翻页+聚焦第一行第一个元素
    if (this.activeDomX === this.paginationPageSize - 1) {
      // 判断下一页是否有数据
      if (
        this.paginationPageIndex <
        Math.ceil(this.formLinesLength / this.paginationPageSize)
      ) {
        // 翻页+聚焦第一行第一个元素
        this.paginationPageIndex++;
        setTimeout(() => {
          this.collectDomData();
          console.log("执行过程3");
          this.focusDom(0, 0, "right");
        }, 0);
      } else {
        // 新增行+翻页+聚焦第一行第一个元素
        this.addFormLine();
        this.paginationPageIndex++;
        setTimeout(() => {
          this.collectDomData();
          console.log("执行过程4");
          this.focusDom(0, 0);
        }, 0);
      }
    } else {
      this.addFormLine();
    }
  }

  // 聚焦到上一个dom
  jumpToPrevInput(x: number, y: number) {
    if (
      x === null ||
      y === null ||
      !this.collectDomList ||
      this.collectDomList.length === 0
    ) {
      return;
    }
    if (x === 0 && y === 0) {
      // 如果是第一个可输入元素， 判断是否有上一页， 如果有，则翻页+聚焦到上一页最后一个元素
      if (this.paginationPageIndex > 1) {
        // 翻页+聚焦到上一页最后一个元素
        this.paginationPageIndex--;
        setTimeout(() => {
          this.collectDomData();
          console.log("执行过程5");
          this.focusDom(
            this.collectDomList.length - 1,
            this.collectDomList[0].length - 1,
          );
        }, 0);
      }
      return;
    } else {
      if (y === 0) {
        console.log("执行过程6");
        // 如果是第一列，则跳转到上一行最后一个输入框
        this.focusDom(x - 1, this.collectDomList[0].length - 1, "left");
      } else {
        console.log("执行过程7");
        // 如果不是第一列，则跳转到当前行上一个输入框
        this.focusDom(x, y - 1, "left");
      }
    }
  }

  /**
   * 聚焦到某个dom
   * @param x 坐标x
   * @param y 坐标y
   * @param jumpDirection 跳转方向
   */
  focusDom(x: number, y: number, jumpDirection: string = "right") {
    if (
      x === null ||
      y === null ||
      !this.collectDomList ||
      this.collectDomList.length === 0
    ) {
      return;
    }
    // 先清除一下当前的焦点
    this.cleanFocusDom(this.activeDomX, this.activeDomY);
    if (this.collectDomList[x] && this.collectDomList[x][y]) {
      const dom = this.collectDomList[x][y];
      // 需要判断下一个focus的dom是否是禁用状态，如果是禁用状态需要跳过
      if (dom instanceof NzSelectComponent) {
        if (dom.nzDisabled) {
          if (jumpDirection === "right") {
            this.jumpToNextInput(x, y);
          } else if (jumpDirection === "left") {
            this.jumpToPrevInput(x, y);
          }
          return;
        }
        dom.nzSelectTopControlComponent.inputElement.nativeElement.scrollIntoView(
          { behavior: "smooth", block: "center", inline: "center" },
        );
        // 这里多选框需要额外处理下，因为向下的时候会触发内部Input的聚焦，把下一个dom的focus放到宏任务中，延迟处理。
        if (dom.nzSelectService.mode === "multiple") {
          setTimeout(() => {
            dom.focus();
          }, 0);
        } else {
          dom.focus();
        }
      } else if (dom instanceof NzInputNumberComponent) {
        if (dom.nzDisabled) {
          if (jumpDirection === "right") {
            this.jumpToNextInput(x, y);
          } else if (jumpDirection === "left") {
            this.jumpToPrevInput(x, y);
          }
          return;
        }
        const inputDom: any = document.getElementById(dom.nzId);
        inputDom.focus();
        inputDom.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
        setTimeout(() => {
          inputDom.select();
        }, 0);
      } else if (dom instanceof ElementRef) {
        if (dom.nativeElement.disabled) {
          if (jumpDirection === "right") {
            this.jumpToNextInput(x, y);
          } else if (jumpDirection === "left") {
            this.jumpToPrevInput(x, y);
          }
          return;
        }
        dom.nativeElement.focus();
        dom.nativeElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
        setTimeout(() => {
          dom.nativeElement.select();
        }, 0);
      } else if (
        dom instanceof NzDatePickerComponent ||
        dom instanceof NzRangePickerComponent ||
        dom instanceof NzTimePickerComponent
      ) {
        // TODO:在ngzorro8.5.x版本，时间相关的选择器没有暴露出open方法，暂时先不处理。（10.x及以上版本提供了open方法）
        if (jumpDirection === "right") {
          this.jumpToNextInput(x, y);
        } else if (jumpDirection === "left") {
          this.jumpToPrevInput(x, y);
        }
        return;
      }
      this.setActiveDom(x, y);
    } else {
      // 没有dom的场景下，需要判断是左还是右，
    }
  }

  cleanFocusDom(x: number, y: number) {
    if (
      x === null ||
      y === null ||
      !this.collectDomList ||
      this.collectDomList.length === 0
    ) {
      return;
    }
    if (this.collectDomList[x] && this.collectDomList[x][y]) {
      const dom = this.collectDomList[x][y];
      if (dom instanceof NzSelectComponent) {
        dom.blur();
        dom.nzOpen = false;
      } else if (dom instanceof NzInputNumberComponent) {
        dom.blur();
      } else if (dom instanceof ElementRef) {
        dom.nativeElement.blur();
      } else {
      }
    }
  }

  setActiveDom(x: number, y: number) {
    this.activeDomX = x;
    this.activeDomY = y;
    this.activeDom = this.collectDomList[this.activeDomX][this.activeDomY];
    if (this.activeDom instanceof NzSelectComponent) {
      this.setActiveSelectedComponentOpen(this.activeDom.open);
    }
  }

  /**
   * 根据行号和列号名称获取当前聚焦的dom位置
   * @param rowNumber 行号
   * @param colNumber 列号
   */
  setActiveDomInFormLines(rowNumber: number, colNumber: number) {
    this.activeDomX = rowNumber;
    this.activeDomY = this.getDomIndex(colNumber, this.formLines);
    this.setActiveDom(this.activeDomX, this.activeDomY);
  }

  /**
   * 键盘点击事件
   * @param event 键盘事件
   * @returns
   */
  onKeyDown(event: KeyboardEvent) {
    if (!this.enableKeyboardOperate) {
      return;
    }
    if (this.activeDomX === null || this.activeDomY === null) {
      return;
    }
    switch (event.key) {
      case "ArrowUp":
        if (
          this.activeDom instanceof NzSelectComponent &&
          this.activeSelectedComponentOpen
        ) {
          return;
        }
        if (this.activeDomX !== 0) {
          this.focusDom(this.activeDomX - 1, this.activeDomY);
        }
        break;
      case "ArrowDown":
        if (
          this.activeDom instanceof NzSelectComponent &&
          this.activeSelectedComponentOpen
        ) {
          return;
        }
        // 判断是否在最后一行，加行
        if (this.activeDomX === this.collectDomList.length - 1) {
          this.cleanFocusDom(this.activeDomX, this.activeDomY);
          this.addNewLineAndFocus();
          break;
        } else {
          this.focusDom(this.activeDomX + 1, this.activeDomY);
        }
        break;
      case "ArrowLeft":
        this.jumpToPrevInput(this.activeDomX, this.activeDomY);
        break;
      case "ArrowRight":
        this.jumpToNextInput(this.activeDomX, this.activeDomY);
        break;
      case "Enter":
        if (this.activeDom instanceof NzSelectComponent) {
          this.setActiveSelectedComponentOpen(this.activeDom.open);
          if (this.activeSelectedComponentOpen === false) {
            this.focusDom(this.activeDomX, this.activeDomY);
          }
        } else if (this.activeDomX === this.collectDomList.length - 1) {
          this.addNewLineAndFocus();
        }
        break;
      case "Escape":
        if (this.activeDom instanceof NzSelectComponent) {
          const nowActiveDom = this.activeDom as NzSelectComponent;
          setTimeout(() => {
            this.setActiveSelectedComponentOpen(nowActiveDom.open);
            if (this.activeSelectedComponentOpen === false) {
              if (nowActiveDom.nzSelectService.mode === "multiple") {
                setTimeout(() => {
                  this.focusDom(this.activeDomX, this.activeDomY);
                }, 0);
              } else {
                this.focusDom(this.activeDomX, this.activeDomY);
              }
            }
          }, 0);
        }
        break;
      default:
        // 如果当前聚焦的是选择框，且键入0-9a-zA-Z，则弹出
        if (
          this.activeDom instanceof NzSelectComponent &&
          this.activeSelectedComponentOpen === false &&
          /^[0-9a-zA-Z]$/.test(event.key)
        ) {
          const dom = this.activeDom;
          dom.nzOpen = true;
          this.setActiveSelectedComponentOpen(true);
          // // TODO:这里暂时注释，不能直接带入键入值，这样会导致输入中文的时候带入英文字符，不符合预期
          // dom.nzSelectTopControlComponent.inputValue = event.key;
          // // 获取 input 元素
          // const inputElement = dom.nzSelectTopControlComponent.inputElement.nativeElement;
          // setTimeout(() => {
          //   // 触发输入事件，以确保 Angular 检测到值的变化
          //   const eventInput = new Event('input', { bubbles: true });
          //   inputElement.dispatchEvent(eventInput);
          // }, 0);
        }
        break;
    }
  }

  /**
   * 根据在初始dom下标和数据集 获取在collectDomList中的下标
   * @param index 初始下标
   * @param list 老数据集
   * @returns
   */
  private getDomIndex(index: number, list: Array<FormLine>): number {
    const typeList = [
      "Input",
      "Select",
      "Date",
      "DateRange",
      "TextArea",
      "InputNumber",
      "MultipleSelect",
    ];
    let filterList = [];
    for (let i = 0; i < list.length; i++) {
      if (i === index) {
        return filterList.length;
      }
      // 与模板一致：hide / isShow=false 的列不渲染 #formInputDom，不计入 collectDomList 的列下标
      if (
        typeList.includes(list[i].type) &&
        !list[i].hide &&
        list[i].isShow !== false
      ) {
        filterList.push(list[i]);
      }
    }
    return null;
  }

  /**
   * 根据在collectDomList中的下标和数据集 获取初始dom下标
   * @param index 新下标
   * @param list 老数据集
   * @returns
   */
  private getOldDomIndex(index: number, list: Array<FormLine>): number {
    console.log("index", index);
    console.log("list", list);
    const typeList = [
      "Input",
      "Select",
      "Date",
      "DateRange",
      "TextArea",
      "InputNumber",
      "MultipleSelect",
    ];
    let filterList = [];
    for (let i = 0; i < list.length; i++) {
      if (
        typeList.includes(list[i].type) &&
        !list[i].hide &&
        list[i].isShow !== false
      ) {
        filterList.push(list[i]);
        if (filterList.length === index + 1) {
          return i;
        }
      }
    }
    return null;
  }

  get linesFormArray(): any {
    return this.validateHdFormLines.get("lines") as FormArray;
  }

  get LodashRound() {
    return round;
  }

  // 暴露的方法，用于获取所有数据的valid状态
  public getValid() {
    return this.formValid;
  }

  onSearchEvent(
    fn: any,
    event: any,
    line: any,
    onSearchEventDebounceTime: any,
  ) {
    if (!fn) {
      return;
    }
    const debounceMs =
      onSearchEventDebounceTime != null ? onSearchEventDebounceTime : 0;
    // 未配置或为 0：同步触发，不走 debounceTime（避免异步）
    if (!debounceMs) {
      this.triggerEvent(fn, event, line);
    } else {
      this.debounceTimeout = debounceMs;
      if (this.searchSubscription) {
        this.searchSubscription.unsubscribe();
      }
      this.searchSubscription = this.searchSubject
        .pipe(debounceTime(this.debounceTimeout))
        .subscribe(({ fn, event, line }) => this.triggerEvent(fn, event, line));
      this.searchSubject.next({ fn, event, line });
    }
    setTimeout(() => {
      this.setActiveSelectedComponentOpen(true);
    }, 0);
  }

  onOpenChangeEvent(
    fn: any,
    open: boolean,
    line: any,
    onOpenChangeEventDebounceTime: any,
    formItem?: any,
  ) {
    if (!fn) {
      return;
    }
    // 展开时先清空旧 options，避免条件变化后请求返回前仍展示上一批下拉数据
    if (open) {
      this.clearSelectOptionsOnOpen(formItem, line);
    }
    const debounceMs =
      onOpenChangeEventDebounceTime != null
        ? onOpenChangeEventDebounceTime
        : 0;
    // 未配置或为 0：同步触发，不走 debounceTime（避免异步）
    if (!debounceMs) {
      if (open) {
        this.triggerEvent(fn, open, line);
      }
      return;
    }
    this.openChangeDebounceTimeout = debounceMs;
    if (this.openChangeSubscription) {
      this.openChangeSubscription.unsubscribe();
    }
    this.openChangeSubscription = this.openChangeSubject
      .pipe(debounceTime(this.openChangeDebounceTimeout))
      .subscribe(({ fn, event, line }) => {
        if (event) {
          this.triggerEvent(fn, event, line);
        }
      });
    this.openChangeSubject.next({ fn, event: open, line });
  }

  /** 有 onOpenChangeEvent 时展开下拉先清空选项，由业务回调再写入新数据 */
  private clearSelectOptionsOnOpen(formItem: any, line: any): void {
    if (!formItem || !formItem.selectOption) {
      return;
    }
    const opt = formItem.selectOption;
    if (opt.selectList != null) {
      opt.selectList = [];
    }
    if (
      opt.selectListName &&
      line &&
      line.get &&
      line.get(opt.selectListName)
    ) {
      line.get(opt.selectListName).setValue([], { emitEvent: false });
    }
  }

  /**
   *
   * @param fn 父组件函数
   * @param event 事件值
   * @param line 触发的行
   */
  triggerEvent(fn: any, event: any, line: any) {
    if (fn) {
      fn(event, line);
    }
  }

  innerGetValid() {
    let tmpValidateHdFormLines = this.fb.group({
      lines: this.fb.array([]),
    });
    this.storeFormLinesData.forEach((formLinesDataItem) => {
      let formGroupObj: any = {};
      this.formLines.forEach((item) => {
        // 新增行 初始数据都为null
        formGroupObj[item.name] = this.fb.control(
          {
            value: this.judgeValueIsNotEmpty(formLinesDataItem[item.name])
              ? formLinesDataItem[item.name]
              : item.value || null,
            disabled: item.disabled,
          },
          item.require ? [Validators.required] : [],
        );
        if (item.selectOption && item.selectOption.label) {
          formGroupObj[item.selectOption.label] = this.fb.control(
            formLinesDataItem[item.selectOption.label] || null,
            [],
          );
        }
      });
      formGroupObj.lineIndex = this.fb.control(
        (tmpValidateHdFormLines.get("lines") as FormArray).controls.length + 1,
        [],
      );
      let formGroupTmp = this.fb.group(formGroupObj);
      this.formLines.forEach((item) => {
        if (item.onChangeEvent) {
          const debounceMs =
            item.onChangeEventDebounceTime != null
              ? item.onChangeEventDebounceTime
              : 0;
          const control = formGroupTmp.get(item.name);
          // 未配置或为 0：同步订阅，不走 debounceTime
          if (debounceMs > 0) {
            control.valueChanges
              .pipe(debounceTime(debounceMs))
              .subscribe((value) => {
                this.triggerEvent(item.onChangeEvent, value, formGroupTmp);
              });
          } else {
            control.valueChanges.subscribe((value) => {
              this.triggerEvent(item.onChangeEvent, value, formGroupTmp);
            });
          }
        }
      });
      (tmpValidateHdFormLines.get("lines") as FormArray).insert(
        (tmpValidateHdFormLines.get("lines") as FormArray).controls.length,
        formGroupTmp,
      );
    });
    return tmpValidateHdFormLines.valid;
  }

  // 暴露的方法，用于获取所有数据
  public getLines() {
    let allLines = [];
    this.storeFormLinesData.forEach((formLinesDataItem) => {
      let formGroupObj: any = {};
      this.formLines.forEach((item) => {
        // 新增行 初始数据都为null
        formGroupObj[item.name] = formLinesDataItem[item.name];
      });
      formGroupObj.lineIndex = formLinesDataItem.lineIndex;
      allLines.push(formGroupObj);
    });
    return allLines;
  }

  // 全局性的搜索（涵盖页面上所有的可视文字）
  searchLines() {
    if (this.storeFormLinesData.length < 1) {
      return;
    }
    this.tableLoading = true;
    // 如果没有输入搜索字符串，则显示缓存内的所有数据
    if (!this.filterStr) {
      this.isFilterData = false;
      this.setStoreData();
      return;
    }
    const filterValue = this.filterStr.trim().toLowerCase();
    this.isFilterData = true;
    this.filterIndexStore = [];

    // 根据搜索字符串过滤数据
    const filteredData = this.storeFormLinesData.filter(
      (data: any, index: number) => {
        for (const item of this.formLines) {
          if (
            (item.hide && item.canSearch) ||
            (!item.hide && item.name !== "uuid")
          ) {
            console.log("item", item.name);
            const value = data[item.name]
              ? data[item.name].toString().toLowerCase()
              : "";
            if (value.includes(filterValue)) {
              this.filterIndexStore.push(index);
              return true;
            }
          }
        }
        return false;
      },
    );
    // 缓存一下筛选后的表单数据
    this.filterStoreFormLinesData = filteredData;
    // 处理筛选好的数据 然后重新渲染
    this.formLinesData = filteredData;
    this.init(true);
  }

  setStoreData() {
    this.formLinesData = this.storeFormLinesData;
    this.init(true);
  }

  getStyle(line: FormGroup, formItem: any, width: string) {
    let styleObj = {
      "min-width": width,
    };
    if (formItem.style) {
      styleObj = { ...styleObj, ...formItem.style };
    }
    if (
      formItem.colorOption &&
      formItem.colorOption.name &&
      line.get(formItem.colorOption.name).value
    ) {
      styleObj = {
        ...styleObj,
        ...{ color: line.get(formItem.colorOption.name).value },
      };
    }
    return styleObj;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes["formLinesData"] &&
      JSON.stringify(changes["formLinesData"].currentValue) !==
        JSON.stringify(changes["formLinesData"].previousValue)
    ) {
      if (this.storeFormLinesData && this.storeFormLinesData.length === 0) {
        this.storeFormLinesData = this.formLinesData;
      }
      this.init();
    }
    if (
      changes["formLines"] &&
      changes["formLines"].previousValue !== undefined &&
      JSON.stringify(changes["formLines"].currentValue) !==
        JSON.stringify(changes["formLines"].previousValue)
    ) {
      this.initColSettings();
    }
    if (
      changes["totalOption"] &&
      JSON.stringify(changes["totalOption"].currentValue) !==
        JSON.stringify(changes["totalOption"].previousValue)
    ) {
      this.calculateTotal();
    }
  }

  calculateTotal() {
    // 这里处理合计数据
    if (this.showTotal) {
      this.totalOptionList = new Array(Number(this.columnsNumber) - 1).fill("");
      this.totalOption.forEach((item) => {
        if (item.insertIndex && (item.insertValue || item.insertValue === 0)) {
          this.totalOptionList[item.insertIndex - 1] = {
            value: item.insertValue,
            align: item.align || "left",
            showDecimal: item.showDecimal || false,
            preserveNumber: item.preserveNumber != null ? item.preserveNumber : 2,
          };
        }
      });
    }
  }

  private init(isEdit: boolean = false): void {
    this.paginationPageIndex = 1;
    // 异常捕获
    if (!this.checkList(this.formLines)) {
      this.tableLoading = false;
      return;
    }
    this.createForm();
    // 如果没有formLinesData，则认为是新增
    if (
      !isEdit &&
      (!this.formLinesData ||
        (this.formLinesData && this.formLinesData.length === 0))
    ) {
      this.tableLoading = false;
      // allowEmpty 且仅删除按钮：不自动补空行
      if (!this.isTrulyEmptyAllowed) {
        this.addFormLine(null, false);
      }
      this.showForm = true;
    } else {
      // 编辑逻辑
      this.addFormLineWithData();
    }
    this.validateHdFormLines.valueChanges.subscribe((data) =>
      this.onHdFormValueChanged(data),
    );
    this.onHdFormValueChanged();
  }

  /**
   * 创建表单
   */
  private createForm() {
    this.validateHdFormLines = this.fb.group({
      lines: this.fb.array([]),
    });
    this.newLine = this.newLineItem();
  }

  delayJumpToNextInput() {
    // 关闭键盘操作时，选择框选中后不自动跳转到下一个输入控件
    if (!this.enableKeyboardOperate) {
      return;
    }
    setTimeout(() => {
      this.jumpToNextInput(this.activeDomX, this.activeDomY);
    }, 0);
  }

  /**
   * 定义空的newLineItem 结构
   */
  private newLineItem(): FormGroup {
    return this.createLineFromValues(null, true);
  }

  /**
   * 根据行数据创建 FormGroup（含隐藏字段、select 的 label 等附属字段）
   * @param formLinesDataItem 行数据，空行传 null
   * @param isEmptyLine 是否空行（影响必填校验规则，与历史逻辑保持一致）
   * @param regenerateRowId 是否强制生成新行 id（复制行时使用）
   */
  private createLineFromValues(
    formLinesDataItem: any,
    isEmptyLine: boolean = false,
    regenerateRowId: boolean = false,
  ): FormGroup {
    let formGroupObj: any = {};
    this.formLines.forEach((item) => {
      formGroupObj[item.name] = this.fb.control(
        {
          value:
            formLinesDataItem != null
              ? formLinesDataItem[item.name]
              : item.value,
          disabled: item.disabled,
        },
        isEmptyLine
          ? item.require && !item.hide
            ? [Validators.required]
            : []
          : item.require
            ? [Validators.required]
            : [],
      );
      if (item.selectOption && item.selectOption.label) {
        formGroupObj[item.selectOption.label] = this.fb.control(
          formLinesDataItem != null
            ? formLinesDataItem[item.selectOption.label] || null
            : null,
          [],
        );
      }
    });

    // 稳定行 id：搜索重建表单后用于保留勾选
    const rowId =
      !regenerateRowId && formLinesDataItem && formLinesDataItem._hdRowId
        ? formLinesDataItem._hdRowId
        : this.generateRowId();
    formGroupObj._hdRowId = this.fb.control(rowId);
    if (formLinesDataItem && !formLinesDataItem._hdRowId) {
      formLinesDataItem._hdRowId = rowId;
    }

    // 复制源行上多余的字段（隐藏附属字段、selectListName 等）
    if (formLinesDataItem) {
      Object.keys(formLinesDataItem).forEach((key) => {
        if (
          key === "lineIndex" ||
          key === "isHdFormLineSearchAdd" ||
          key === "_hdRowId"
        ) {
          return;
        }
        if (!formGroupObj[key]) {
          formGroupObj[key] = this.fb.control(formLinesDataItem[key]);
        }
      });
    }

    formGroupObj.lineIndex = this.fb.control(
      this.linesFormArray.controls.length + 1,
      [],
    );
    formGroupObj.isHdFormLineSearchAdd = this.fb.control(this.isFilterData, []);
    let formGroupSubmit = this.fb.group(formGroupObj);
    this.formLines.forEach((item) => {
      if (item.onChangeEvent) {
        const debounceMs =
          item.onChangeEventDebounceTime != null
            ? item.onChangeEventDebounceTime
            : 0;
        const control = formGroupSubmit.get(item.name);
        const handleChange = (value: any) => {
          if (item.type === FormLineType.Select && value !== null) {
            this.delayJumpToNextInput();
          }
          this.triggerEvent(item.onChangeEvent, value, formGroupSubmit);
        };
        // 未配置或为 0：同步订阅，不走 debounceTime
        if (debounceMs > 0) {
          control.valueChanges
            .pipe(debounceTime(debounceMs))
            .subscribe(handleChange);
        } else {
          control.valueChanges.subscribe(handleChange);
        }
      }
    });
    return formGroupSubmit;
  }

  private calculateLineNumber() {
    this.linesFormArray.controls.forEach((item, index) => {
      item.get("lineIndex").setValue(index + 1, { emitEvent: false });
    });
  }

  /**
   * 编辑的时候数据处理
   */
  addFormLineWithData() {
    this.formLinesData.forEach((formLinesDataItem) => {
      this.linesFormArray.insert(
        this.linesFormArray.controls.length,
        this.createLineFromValues(formLinesDataItem),
      );
    });
    this.calculateLineNumber();
    this.tableLoading = false;
    this.showForm = true;
  }

  /**
   * 在指定行下方新增空行；不传 afterLine 则追加到末尾
   * @param afterLine 当前行 FormGroup（不要传 lineIndex，避免序号偏移导致插错位置）
   */
  addFormLine(afterLine?: FormGroup | null, isFocus: boolean = true) {
    const insertAt = this.getInsertIndexAfter(afterLine);
    const newLine = this.newLineItem();
    this.linesFormArray.insert(insertAt, newLine);
    this.calculateLineNumber();
    this.addLineEvent.emit(newLine);
    // 跳到新增行所在页，避免页码异常时看不到数据
    this.paginationPageIndex =
      Math.floor(insertAt / this.paginationPageSize) + 1;
    setTimeout(() => {
      this.collectDomData();
      if (isFocus) {
        this.activeDomX = this.toPageLocalRowIndex(insertAt);
        this.activeDomY = 0;
        console.log("执行过程13");
        this.focusDom(this.activeDomX, this.activeDomY);
      }
    }, 0);
  }

  /**
   * 复制当前行：在当前行下方新增一行，复制所有字段值（含隐藏字段）
   */
  copyFormLine(line: FormGroup) {
    const sourceIndex = this.linesFormArray.controls.indexOf(line);
    if (sourceIndex < 0) {
      return;
    }
    // getRawValue 包含 disabled 字段；复制行使用新的 _hdRowId
    const sourceValues = line.getRawValue();
    const insertAt = sourceIndex + 1;
    this.linesFormArray.insert(
      insertAt,
      this.createLineFromValues(sourceValues, false, true),
    );
    this.calculateLineNumber();
    setTimeout(() => {
      this.collectDomData();
      this.activeDomX = this.toPageLocalRowIndex(insertAt);
      this.activeDomY = 0;
      this.focusDom(this.activeDomX, this.activeDomY);
    }, 0);
  }

  @Output() deleteLineEvent = new EventEmitter();

  /**
   * 删除行
   * @param lineOrIndex 行 FormGroup，或 1-based 的 lineIndex（兼容 resetForm）
   */
  deleteFormLine(lineOrIndex: FormGroup | number) {
    let removeAt = -1;
    if (typeof lineOrIndex === "number") {
      removeAt = lineOrIndex - 1;
    } else if (lineOrIndex) {
      removeAt = this.linesFormArray.controls.indexOf(lineOrIndex);
    }
    console.log(
      "index",
      typeof lineOrIndex === "number" ? lineOrIndex : removeAt,
    );
    if (removeAt < 0) {
      return;
    }
    // 最后一条数据的时候要判断一下
    if (this.linesFormArray.controls.length === 1 && !this.allowEmpty) {
      if (this.deleteLastLineEvent) {
        this.deleteLastLineEvent.emit();
      }
      return;
    }
    const removedLine = this.linesFormArray.at(removeAt) as FormGroup;
    this.linesFormArray.removeAt(removeAt);
    this.removeLineFromSelection(removedLine);
    if (
      !this.isFilterData &&
      this.linesFormArray.controls &&
      this.linesFormArray.controls.length === 0 &&
      !this.isTrulyEmptyAllowed
    ) {
      this.addFormLine();
    } else {
      // 当前页已无数据时回退页码，且页码最小为 1（避免删空后变成 0 导致再添加看不见）
      const maxPage = Math.max(
        1,
        Math.ceil(
          this.linesFormArray.controls.length / this.paginationPageSize,
        ),
      );
      if (this.paginationPageIndex > maxPage) {
        this.paginationPageIndex = maxPage;
      }
      this.calculateLineNumber();
    }
    setTimeout(() => {
      this.collectDomData();
    }, 0);
  }

  /** 在指定行后方的插入下标；无行则追加到末尾 */
  private getInsertIndexAfter(afterLine?: FormGroup | null): number {
    if (!afterLine) {
      return this.linesFormArray.controls.length;
    }
    const idx = this.linesFormArray.controls.indexOf(afterLine);
    return idx >= 0 ? idx + 1 : this.linesFormArray.controls.length;
  }

  /** 全局行下标转当前页内的行下标（供聚焦用） */
  private toPageLocalRowIndex(globalIndex: number): number {
    return (
      globalIndex - (this.paginationPageIndex - 1) * this.paginationPageSize
    );
  }

  public pageIndexChange(event: number): void {
    this.paginationPageIndex = event;
    setTimeout(() => {
      this.collectDomData();
    }, 0);
  }

  public pageSizeChange(event: number): void {
    this.paginationPageSize = event;
    setTimeout(() => {
      this.collectDomData();
    }, 0);
  }

  private onHdFormValueChanged(data?: any) {
    if (this.isFilterData) {
      if (data && data.lines && this.filterIndexStore.length !== 0) {
        const lines = data.lines;
        if (lines.length === this.filterIndexStore.length) {
          this.filterIndexStore.forEach((item, index) => {
            this.storeFormLinesData[item] = {
              ...this.filterStoreFormLinesData[index],
              ...lines[index],
            };
          });
        } else if (lines.length > this.filterIndexStore.length) {
          // 有新增数据的情况
          // step 1: 先找新增的index下标
          const getNowLines = this.validateHdFormLines.getRawValue().lines;
          let addIndex = -1;
          for (let i = 0; i < getNowLines.length; i++) {
            if (getNowLines[i].isHdFormLineSearchAdd) {
              addIndex = i;
              break;
            }
          }
          if (addIndex !== -1) {
            this.storeFormLinesData.splice(
              this.filterIndexStore[addIndex - 1] + 1,
              0,
              getNowLines[addIndex],
            );
          }
          this.filterIndexStore.push(this.filterIndexStore[addIndex - 1] + 1);
        } else {
          // 有删除数据的情况
          // step 1:先找到删除的index下标
          let deletedIndex = -1;
          let count = 0;
          if (lines.length === 0) {
            deletedIndex = 0;
          } else {
            for (let i = 0; i < lines.length; i++) {
              if (lines[i].lineIndex - count > 1) {
                deletedIndex = i;
                break;
              }
              count++;
            }
          }
          if (deletedIndex !== -1) {
            // step 2: 删除总数据中的对应数据, 把下标数组和lines长度对齐，同时把下标数组在deletedIndex后面的值全都-1
            this.storeFormLinesData = this.storeFormLinesData.filter(
              (item, index) => {
                return index !== this.filterIndexStore[deletedIndex];
              },
            );
            this.filterIndexStore.splice(deletedIndex, 1);
            for (let i = 0; i < this.filterIndexStore.length; i++) {
              if (i >= deletedIndex) {
                this.filterIndexStore[i]--;
              }
            }
          } else {
            // step 2: 没有找到deletedIndex说明删除操作在最后一行
            const filterIndex =
              this.filterIndexStore[this.filterIndexStore.length - 1];
            this.storeFormLinesData = this.storeFormLinesData.filter(
              (item, index) => {
                return index !== filterIndex;
              },
            );
            this.filterIndexStore.pop();
          }
        }
      } else {
        if (data && data.lines) {
          this.storeFormLinesData = data.lines;
        }
      }
    } else {
      if (data && data.lines) {
        this.storeFormLinesData = data.lines;
      }
    }

    // 总表单
    if (!this.isFilterData) {
      this.formValid = this.validateHdFormLines.valid;
    } else {
      if (this.formValid) {
        // 如果整体表单是true，不管子表单是什么，都变成子表单的状态
        this.formValid = this.validateHdFormLines.valid;
      } else {
        // 如果整体表单是false：1、子表单为true，需要重算；2、子表单为false，用子表单状态
        if (this.validateHdFormLines.valid) {
          this.formValid = this.innerGetValid();
        } else {
          this.formValid = this.validateHdFormLines.valid;
        }
      }
    }
    // this.calculateLineNumber();
    this.changeEvent.emit(this.validateHdFormLines);
  }

  private checkList(list: Array<FormLine>): boolean {
    if (!list || (list && list.length === 0)) {
      return false;
    }
    let nameList = [];
    let selectOptionCheckList = [];
    list.forEach((item) => {
      // 校验单项选择器
      // if (item.type === FormLineType.Select && (!item.selectList || (item.selectList && item.selectList.length === 0))) {
      //   throw 'formLines组件数据格式不规范，存在单项选择器没有传入选项!'
      // }
      nameList.push(item.name);

      // 校验有onSearch的字段的selectOption的value、label是否在formLine里面都定义了
      if (item.onSearchEvent && item.selectOption) {
        selectOptionCheckList = [];
        list.forEach((innerItem) => {
          if (
            innerItem.name === item.selectOption.value ||
            innerItem.name === item.selectOption.label
          ) {
            selectOptionCheckList.push(innerItem.name);
          }
        });
        if (selectOptionCheckList.length < 2) {
          throw `formLines组件数据格式不规范，字段${item.name}的selectOption的value、label字段未能在formLines中找到对应字段！`;
        }
      }
    });
    // 校验name是否重复
    if ([...new Set(nameList)].length !== list.length) {
      throw "formLines组件数据格式不规范，存在重复name值!";
    }
    // ...more check
    return true;
  }

  public submitForm(): void {
    this.changeEvent.emit(this.validateHdFormLines.getRawValue());
  }

  public resetForm(): void {
    // 删除
    this.clearSelection();
    for (let i = this.linesFormArray.controls.length; i >= 0; i--) {
      this.deleteFormLine(i);
    }
    this.paginationPageIndex = 1;
  }

  public inputClean(formItem: any, line: any): void {
    line.get(formItem.name).setValue(null);
  }

  public selectValue(id: string, rowNumber: number, colNumber: number): void {
    const inputDom: any = document.querySelector(id);
    inputDom.select();
    this.setActiveDomInFormLines(rowNumber, colNumber);
  }

  private textWidthCache: { [key: string]: number } = {};

  isTextOverflow(text: string, maxWidth: number): boolean {
    const cachedWidth = this.textWidthCache[text];
    if (cachedWidth !== undefined) {
      return cachedWidth + 15 >= maxWidth;
    }

    const span = document.createElement("span");
    span.style.visibility = "hidden";
    span.style.position = "absolute";
    span.style.whiteSpace = "nowrap";
    span.style.fontSize = "14px";
    span.style.display = "inline-block"; // 将样式修改为 inline-block
    span.innerText = text;
    document.body.appendChild(span);
    const isOverflow = span.offsetWidth + 15 >= maxWidth;
    this.textWidthCache[text] = span.offsetWidth;
    span.style.display = "none";
    document.body.removeChild(span);
    return isOverflow;
  }

  judgeColEmpty(str: any) {
    if (str || str === 0) {
      return str;
    } else {
      return "<空>";
    }
  }

  judgeValueIsNotEmpty(str: any) {
    if (str === null && str === undefined) {
      return false;
    } else {
      return true;
    }
  }
}
